import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import SearchBox from './SearchBox';
import { comicCategories } from '@/mocks/comics';

const navItems = [
  { label: '首页', to: '/' },
  { label: '分类', to: '/category/action' },
  { label: '热门', to: '/list?sort=hot' },
  { label: '新作', to: '/list?sort=new' },
  { label: '排行', to: '/list?sort=rank' },
  { label: '收藏', to: '/user/favorites' },
  { label: '关于', to: '/about' },
];

export default function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 12);
    handler();
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCategoryOpen(false);
  }, [location.pathname, location.search]);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition ${
        scrolled ? 'bg-background-50/95 shadow-[0_1px_0_0_rgba(0,0,0,0.06)] backdrop-blur' : 'bg-background-50'
      }`}
    >
      <div className="flex h-16 w-full items-center gap-4 px-4 md:px-8">
        <Link to="/" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg font-bold text-background-50">
            抖
          </span>
          <span className="font-heading text-2xl leading-none text-foreground-950">抖漫</span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) =>
            item.label === '分类' ? (
              <div
                key={item.to}
                className="relative"
                onMouseEnter={() => setCategoryOpen(true)}
                onMouseLeave={() => setCategoryOpen(false)}
              >
                <NavLink
                  to={item.to}
                  className={({ isActive }) =>
                    `flex items-center gap-0.5 whitespace-nowrap rounded-md px-3 py-2 text-sm transition ${
                      isActive || location.pathname.startsWith('/category')
                        ? 'text-primary-600 font-medium'
                        : 'text-foreground-700 hover:text-primary-600'
                    }`
                  }
                >
                  {item.label}
                  <i className="ri-arrow-down-s-line text-sm" />
                </NavLink>
                {categoryOpen && (
                  <div className="absolute left-0 top-full w-[420px] rounded-lg border border-background-200 bg-background-50 p-3 shadow-sm">
                    <div className="grid grid-cols-3 gap-1">
                      {comicCategories.map((category) => (
                        <Link
                          key={category.id}
                          to={`/category/${category.id}`}
                          className="flex items-center gap-2 rounded-md px-2 py-2 text-sm text-foreground-700 transition hover:bg-primary-50 hover:text-primary-600"
                        >
                          <i className={`${category.icon} text-primary-500`} />
                          {category.name}
                        </Link>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ) : item.to.includes('?') ? (
              <Link
                key={item.to}
                to={item.to}
                className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition hover:text-primary-600"
              >
                {item.label}
              </Link>
            ) : (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `whitespace-nowrap rounded-md px-3 py-2 text-sm transition ${
                    isActive ? 'text-primary-600 font-medium' : 'text-foreground-700 hover:text-primary-600'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ),
          )}
        </nav>

        <div className="hidden min-w-0 flex-1 justify-end md:flex lg:max-w-sm">
          <SearchBox />
        </div>

        <div className="flex flex-1 justify-end md:hidden">
          <button
            type="button"
            onClick={() => setMobileOpen((prev) => !prev)}
            aria-label="打开菜单"
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 transition hover:bg-background-100 cursor-pointer"
          >
            <i className={mobileOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-3 md:hidden">
          <div className="mb-3">
            <SearchBox />
          </div>
          <nav className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `flex items-center gap-2 rounded-md px-3 py-2.5 text-sm transition ${
                    isActive ? 'bg-primary-50 text-primary-600 font-medium' : 'bg-background-100 text-foreground-700'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <div className="mt-3">
            <p className="mb-2 px-1 text-xs text-foreground-500">热门分类</p>
            <div className="flex flex-wrap gap-2">
              {comicCategories.slice(0, 6).map((category) => (
                <Link
                  key={category.id}
                  to={`/category/${category.id}`}
                  className="flex items-center gap-1 rounded-full bg-background-100 px-3 py-1.5 text-xs text-foreground-700"
                >
                  <i className={`${category.icon} text-primary-500`} />
                  {category.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}